export default class StandSelected {
  public static readonly SET_DATA = "STAND_SELECTED_SET_DATA";
  public static readonly SET_USER_CUTAWAY_STATUS = "STAND_SELECTED_SET_USER_CUTAWAY_STATUS";
  public static readonly SET_STATUS = "STAND_SELECTED_SET_STATUS";
  public static readonly SET_ERROR = "STAND_SELECTED_SET_ERROR";
  public static readonly CLEAR = "STAND_SELECTED_CLEAR";

  public static setData(data: any) {
    return {
      data,
      type: StandSelected.SET_DATA,
    };
  }

  public static setUserCutawayStatus(data: { status: number, user_id: number }) {
    return {
      data,
      type: StandSelected.SET_USER_CUTAWAY_STATUS,
    };
  }

  public static setStatus(data: any) {
    return {
      data,
      type: StandSelected.SET_STATUS,
    };
  }

  public static setError(data: any) {
    return {
      data,
      type: StandSelected.SET_ERROR,
    };
  }

  public static clear() {
    return {
      type: StandSelected.CLEAR,
    };
  }
}
